import React, { useContext } from 'react';
import { AlertMessage } from '../../commonComponents';
import {
  CLASSIC_LENS_TAB,
  LOOKS_TAB,
  MAKEUP_TAB,
  FRESH_LENS_TAB,
  language,
  LANG_JP,
} from 'Root/constants';
import AppContext from '../../context';
import VmContext from '../context';
import content from 'Content/content.json';
import ProductTutorial from './ProductTutorial';
import LooksTutorial from './LooksTutorial';
import MakeupTutorial from './MakeupTutorial';

const Tutorial = () => {
  const { lensCleared, looksCleared, look, makeupCleared } = useContext(
    AppContext
  );
  const {
    selectedTab,
    selectedLensType,
    lensIndex,
    tempRecommendedLens,
    tempRecommendedLook,
    currentLookIndex,
  } = useContext(VmContext);
  const {
    productInfo: {
      [language]: { [selectedLensType]: lens },
    },
    looks,
  } = content.data;
  const showProduct =
    (selectedTab === CLASSIC_LENS_TAB || selectedTab === FRESH_LENS_TAB) &&
    !lensCleared;
  const showLook = selectedTab === LOOKS_TAB && !looksCleared;
  const showMakeup = selectedTab === MAKEUP_TAB && !lensCleared;

  return (
    <section className="content--component__main">
      {showProduct && (
        <ProductTutorial
          lookIndex={currentLookIndex}
          selectedLensType={selectedLensType}
          lensIndex={lensIndex}
        />
      )}

      {lensCleared && language !== LANG_JP && (
        <AlertMessage
          id="tabs.pls_select_lens"
          defaultMessage="Please select a lens"
        />
      )}
      {showLook && (
        <LooksTutorial
          look={look}
          looks={looks}
          recommendationLens={tempRecommendedLens}
          recommendation={tempRecommendedLook}
          selectedLensType={selectedLensType}
          lens={lens}
          lensSelected={lensIndex}
        />
      )}
      {selectedTab === LOOKS_TAB && looksCleared && (
        <div className="md-text-medium text-center my-2 s">
          <FormattedMessage
            id="tabs.pls_select_look"
            defaultMessage="Please select a look"
          />
        </div>
      )}
      {showMakeup && (
        <MakeupTutorial
          selectedLensType={selectedLensType}
          lensIndex={lensIndex}
        />
      )}
      {selectedTab === MAKEUP_TAB && makeupCleared && (
        <AlertMessage
          id="tabs.pls_select_makeup_category"
          defaultMessage="Please select a makeup category"
        />
      )}
    </section>
  );
};

export default Tutorial;
